/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Tab_Catalogue_DescriptionInputs */



/**
* | output |
* | --- |
* | "Integrations that give the assistant tools it can call." |
*
* @param {Integrations_Tab_Catalogue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_tab_catalogue_description = /** @type {((inputs?: Integrations_Tab_Catalogue_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Tab_Catalogue_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Integrationen, die dem Assistenten aufrufbare Tools bereitstellen.")
	return /** @type {LocalizedString} */ ("Integrations that give the assistant tools it can call.")
});